.item-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  user-select: none;
  padding: 0.8rem 1.6rem;

  & > svg {
    width: 1.6rem;
    height: 1.6rem;
    fill: var(--color-grayscale-shuttle);
  }

  &:hover {
    background: var(--color-grayscale-tuna);
  }
}

.item {
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
}
